import { http } from 'interfaces'
import type { KwComment } from 'services/us/commentService'

interface CommentUpdatePayload {
  comment: string
}

export const internationalCommentService = {
  async getComment (type: string, id: number): Promise<KwComment> {
    const response = await http.get(`/api/v1/comment/?type=${type}&id=${id}`)
    return {
      ...response.data,
      text: response.data.comment
    }
  },

  async updateComment (type: string, id: number, payload: CommentUpdatePayload): Promise<void> {
    await http.put(`/api/v1/comment/?type=${type}&id=${id}`, payload)
  }
}
